var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{attrs:{"elements":_vm.formElements},model:{value:(_vm.bookingExport),callback:function ($$v) {_vm.bookingExport=$$v},expression:"bookingExport"}})}
var staticRenderFns = []

export { render, staticRenderFns }